<div
  class="fixed-bottom fixed-footer-bottom"
  [hidden]="cookiesCheck == true && cookiesCheck == true"
>
  <div class="footer-cookies p-0">
    <div>
      <p>
        {{ "FOOTER.ACCEPT_COOKIES" | translate }}
        <a href="http://wikipedia.org/wiki/HTTP_cookie" target="_blank">{{
          "FOOTER.MORE_INFO" | translate
        }}</a>
      </p>
    </div>
    <div class="cookies-btn-group">
      <button class="btn btn-theme mr-2" type="button" (click)="setCookies()">
        {{ "FOOTER.ACCEPT" | translate }}
      </button>
    </div>
    <a
      href="javascript:void(0);"
      class="cn-close-icon"
      (click)="closeCookies()"
    >
      <span class="mdi mdi-close"></span>
    </a>
  </div>
</div>
<footer class="footer">
  <div class="container d-none home-footer">
    <div class="row justify-content-between mr-0">
      <div class="col-6 col-sm-3 col-lg-4">
        <div class="footer-logo">
          <img src="assets/images/logo-white.svg" />
        </div>
      </div>
      <div
        class="
          col-6 col-sm-3 col-lg-4
          d-flex
          justify-content-center
          justify-content-sm-start
          justify-content-md-start
        "
      >
        <div>
          <h2 class="mb-2">
            {{ "QUICK_LINKS.TITLE" | translate }}
          </h2>
          <ul class="ul-links">
            <li>
              <a
                [routerLink]="['/']"
                [queryParams]="{ data: 'aboutus' }"
                (click)="navigateTo('aboutus')"
                class="text-secondary"
                [ngClass]="{ active: activeStatus == 'aboutus' }"
              >
                {{ "QUICK_LINKS.ABOUTUS" | translate }}
              </a>
            </li>
            <li>
              <a
                [routerLink]="['/']"
                [queryParams]="{ data: 'series' }"
                (click)="navigateTo('series')"
                [ngClass]="{ active: activeStatus == 'series' }"
                class="text-secondary"
              >
                {{ "QUICK_LINKS.COURSES" | translate }}
              </a>
            </li>
            <li>
              <a
                [routerLink]="['/']"
                [queryParams]="{ data: 'plan' }"
                (click)="navigateTo('plan')"
                [ngClass]="{ active: activeStatus == 'plan' }"
                class="text-secondary"
              >
                {{ "QUICK_LINKS.PLAN" | translate }}
              </a>
            </li>
            <li>
              <a
                routerLinkActive="active"
                routerLink="/contact-us"
                class="text-secondary"
              >
                {{ "QUICK_LINKS.HELP" | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="
          col-12 col-sm-6 col-lg-4
          d-flex
          justify-content-center justify-sm-content-end
        "
      >
        <div>
          <h2 class="mb-2">{{ "FOOTER.CONNECT_WITH_US" | translate }}</h2>
          <div class="w-100 mt-3">
            <div class="form-group d-flex align-items-center flex-wrap mb-2">
              <label class="w-auto pr-2"> Address: </label>
              <p class="text-secondary mb-0">
                {{ "CONTACTUS.FULL_ADDRESS" | translate }}
              </p>
            </div>
            <div class="form-group d-flex align-items-center mb-2">
              <label class="w-auto pr-2"> Phone: </label>
              <p class="text-secondary mb-0">
                {{ "CONTACTUS.PHONE_NUMBER" | translate }}
              </p>
            </div>
            <div class="form-group d-flex align-items-center mb-2">
              <label class="w-auto pr-2"> Email: </label>
              <p class="text-secondary mb-0">
                <a
                  href="javascript:void(0)"
                  class="text-secondary mb-0"
                  target="_blank"
                  href="mailto:info@intelligens.com"
                >
                  {{ "CONTACTUS.EMAIL_ID" | translate }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="copyright">
    <div class="container">
      <div
        class="row footer-row justify-content-between align-items-center m-0"
      >
        <div class="d-flex align-items-center footerheade">
          <!-- <h2 class="mr-2">Media Inquires :</h2>
          <a href="mailto:unleashedpress@redbanyan.com" class="orange-link"
            >unleashedpress@redbanyan.com</a
          > -->
        </div>
        <div>
          <ul>
            <li>
              <a routerLinkActive="active" [routerLink]="['/privacy-policy']">{{
                "FOOTER.PRIVACY_POLICY" | translate
              }}</a>
            </li>
            <li class="li_saprater">|</li>
            <li>
              <a
                routerLinkActive="active"
                [routerLink]="['/terms-condition']"
                >{{ "FOOTER.TERMS_AND_CONDITION" | translate }}</a
              >
            </li>
            <li class="li_saprater">|</li>
            <!-- <li>
              <a routerLinkActive="active" routerLink="/code-of-conduct">
                {{ "FOOTER.CODE_OF_CONDUCT" | translate }}
              </a>
            </li>
            <li class="li_saprater">|</li> -->
            <!-- <li>
              <a routerLinkActive="active" routerLink="/refund-policy">
                {{ "FOOTER.REFUND_POLICY" | translate }}
              </a>
            </li>
            <li class="li_saprater">|</li> -->

            <!-- <li>
              <a routerLinkActive="active" routerLink="/disclaimer">
                {{ "FOOTER.DISCLAIMER" | translate }}
              </a>
            </li>
            <li class="li_saprater">|</li> -->

            <li>
              <a routerLinkActive="active" routerLink="/contact-us">
                {{ "FOOTER.CONTACT_US" | translate }}
              </a>
            </li>
            <!-- <li class="li_saprater">|</li> -->

            <!-- <li>
              <a routerLinkActive="active" [routerLink]="['/faq']">{{
                "FOOTER.FAQ" | translate
              }}</a>
            </li> -->
            <li class="copy-link">
              <a [href]="appConstant.baseUrl" target="blank"
                >&#169; {{ "FOOTER.COPY_RIGHTS" | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
